<template>
    <section class="app-main">
        
        <div class="top-bar">
            <el-input placeholder="输入广告位名称" v-model="searchVal" @change="search" style="width:240px;margin-right:30px">
                <i slot="prefix" class="el-input__icon el-icon-search"></i>
            </el-input>
            <el-button  class="top-btn" type="primary" plain @click="handleShow()">添加</el-button >
        </div>

        <el-card >
            <el-table :data="tableData"  height="580">
                <el-table-column prop="title" label="名称" align="center"></el-table-column>
                <el-table-column prop="updated_at"  align="center" label="时间"></el-table-column>
                <el-table-column label="编辑" align="center">
                <template slot-scope="scope">
                    <el-button type="primary" plain size="mini"  @click="goDetail(scope.row)">详情</el-button>
                    <el-button type="success" plain size="mini"  @click="handleShow(scope.row)">修改</el-button>
                    <el-button type="danger"  plain size="mini"  @click="handleDel(scope.row)">删除</el-button>
                </template>
            </el-table-column>
            </el-table>
            <el-pagination background @current-change="reloadData" layout="prev, pager, next, jumper" style="padding:15px" :total="total" :page-size="size"></el-pagination>
        </el-card>



        <el-dialog :visible.sync="dialog" :title="dialogTitle"  width="600px" align="center">
           <el-row >
               <el-col :span="4" class="item-label">广告位名称：</el-col>
               <el-col :span="20">
                   <el-input placeholder="广告位名称" v-model="title" ></el-input>
               </el-col>
           </el-row>
           <el-row type="flex" class="row-bg" justify="center">
                <el-col :span="6" style="text-align:center"><el-button :disabled="disabled" type="info"    plain @click="dialog = false" style="width:120px">取消</el-button></el-col>
                <el-col :span="6" style="text-align:center"><el-button :disabled="disabled" type="primary" plain @click="handleBtn" style="width:120px">确定</el-button></el-col>
            </el-row>
        </el-dialog>



    </section>
</template>



<script>
import { adv_list, adv_add, adv_put, adv_del  } from '@/api/market.js'

export default {

    data() {
        return {
            searchVal: '',
            tableData:[],
            table_load:false,
            total:0,
            page: 1,
            size: 0,
            dialog:false,    // 控制显示 添加修改弹窗
            dialogTitle:'添加广告位',
            id:'',           //  有id 是修改  没有id是添加
            title:'',
            disabled: false,
            bannerData:[],
            bannerShow: false


        }
    },
    methods: {
        search(){
            this.page = 1
            this.getData()
        },
        getData(){
            let params = {
                page:this.page,
                is_page: 1
            }
            adv_list(params).then(res => {
                if(res){
                    this.tableData = res.data.data
                    this.total = res.data.total
                    this.size  = res.data.per_page
                }
            })
        },
        reloadData(page){
            this.page = page;
            this.getData();
        },
        // 显示 添加 || 修改 弹窗
        handleShow(row){
            if(row){
                this.dialog      = true
                this.dialogTitle = '修改广告位'
                this.id          = row.place_id
                this.title       = row.title
            }else{
                this.dialog      = true
                this.dialogTitle = '添加广告位'
                this.id        = ''
                this.title      = ''
            }
        },
        // 弹窗里面 点击确定
        handleBtn(){
            // 通过 this.id 为空来判断 添加 || 修改
            if(this.id == ""){
                this.handleAdd()
            }else{
                this.handlePut()
            }
            
        },

        // 添加广告位位置
        handleAdd() {
            if(this.title == "") {
                return false
            }
            let params = {
                title: this.title,
                status: 1
            }
            this.disabled = true
            adv_add(params).then(res => {
                if(res) {
                    this.$message({message:res.msg,type:'success'})
                    this.getData()
                }
            }).finally( () => {
                this.dialog   = false
                this.disabled = false
            })
        },

        // 修改广告位位置
        handlePut() {
            if(this.title == "") {
                return false
            }
            if(this.id == "") {
                return false
            }
            let params = {
                title: this.title
            }
            this.disabled = true
            adv_put(this.id, params).then(res => {
               if(res) {
                    this.$message({message:res.msg,type:'success'})
                    this.getData()
                }
            }).finally( () => {
                this.dialog   = false
                this.disabled = false
            })
        },

        // 删除 广告位位置
        handleDel(row) {
             this.$confirm(`此操作将删除广告位：${row.title}，是否继续?`, '提示', {
                confirmButtonText: '确定',
                cancelButtonText: '取消',
                type: 'error'
            }).then(() => {
                adv_del(row.place_id).then(res => {
                    this.$message({type:"success",message:res.msg})
                    this.getData();
                })
            })
        },

        // 跳转广告位详情
        goDetail(row) {
            this.$router.push( {path: `/market/adv/edit/${row.place_id}`, query: { title: row.title }} )
        },
       
    },
    created(){
        this.getData()
    },
    activated() {
        this.getData()
    },
}
</script>

<style lang="less" scoped>
section {
    width: 100%;
    height: calc(100% - 65px);
    .top-btn {
        width: 100px;
    }
    .item-label {
        height: 40px;
        line-height: 40px;
    }
    .row-bg {
        margin-top: 25px;
    }

}
</style>
